window.EVOMAX_GALLERY_MAP = {
  "camo-core-hoodie": {
    "Black Camo": [
      "unisex-heavyweight-hooded-sweatshirt-black-camo-front-6aaebd274e28d.jpg",
      "unisex-heavyweight-hooded-sweatshirt-black-camo-back-6aaebd275032c.jpg"
    ],
    "Darkwood Tree Camo": [
      "unisex-heavyweight-hooded-sweatshirt-darkwood-tree-camo-front-6aaebd274f7f4.jpg",
      "unisex-heavyweight-hooded-sweatshirt-darkwood-tree-camo-back-6aaebd2750415.jpg"
    ],
    "Forest Camo": [
      "unisex-heavyweight-hooded-sweatshirt-forest-camo-front-6aaebd274f7c2.jpg",
      "unisex-heavyweight-hooded-sweatshirt-forest-camo-back-6aaebd27503e4.jpg"
    ],
    "Duck Camo": [
      "unisex-heavyweight-hooded-sweatshirt-duck-camo-front-6aaebd274f78a.jpg",
      "unisex-heavyweight-hooded-sweatshirt-duck-camo-back-6aaebd27503b2.jpg"
    ],
    "Deadwood Tree Camo": [
      "unisex-heavyweight-hooded-sweatshirt-deadwood-tree-camo-front-6aaebd274f725.jpg",
      "unisex-heavyweight-hooded-sweatshirt-deadwood-tree-camo-back-6aaebd275037d.jpg"
    ]
  },
  "evomax-stickers-1": {
    "Gold": [
      "Untitleddesign-2026-03-17T004908.744.png"
    ]
  },
  "unisex-midweight-softstyle-fleece-hoodie-1": {
    "Paragon": [
      "20260317152647-1f12215b-6283-672e-821e-f26ccc857799.png",
      "20260317152647-1f12215b-68d0-6348-8e92-667c8eb1b386.png"
    ],
    "Daisy": [
      "20260317152647-1f12215b-6593-6130-9def-d68677e97d27.png",
      "20260317152647-1f12215b-66c1-67fa-9cf0-926726e4ef75.png"
    ],
    "Dark Heather": [
      "20260317152647-1f12215b-691c-68b0-ba57-16ec3a650015.png",
      "20260317152647-1f12215b-69cf-63fc-9515-f21eb9380f3f.png"
    ],
    "Navy": [
      "20260317152646-1f12215b-5ad1-6224-ac5a-d68677e97d27.png",
      "20260317152647-1f12215b-6109-66f0-9fd2-16ec3a650015.png"
    ],
    "Red": [
      "20260317152646-1f12215b-5bd6-6868-a192-b6b65fe7774c.png",
      "20260317152647-1f12215b-6582-60f6-8839-f67065cb552b.png"
    ],
    "Royal": [
      "20260317152646-1f12215b-5f94-664e-acd3-6ebff3a88be9.png",
      "20260317152647-1f12215b-641b-6618-9c20-fa14d8a9840d.png"
    ],
    "Sand": [
      "20260317152647-1f12215b-684e-6528-a0c2-c659e166c14a.png",
      "20260317152647-1f12215b-6769-619e-8467-e634b792a2bc.png"
    ],
    "White": [
      "20260317152646-1f12215b-5d4d-6836-adfe-667c8eb1b386.png",
      "20260317152647-1f12215b-6477-65f8-a82b-a2594d4c901c.png"
    ],
    "Sport Grey": [
      "20260317152647-1f12215b-6905-6048-a8ff-32c95e3442e8.png",
      "20260317152647-1f12215b-69c0-6b4a-998f-f21eb9380f3f.png"
    ],
    "Tangerine": [
      "20260317152647-1f12215b-632e-644e-bf52-e20372856a5c.png",
      "20260317152647-1f12215b-65aa-6826-b7da-7ea95006f86e.png"
    ],
    "Black": [
      "20260317152646-1f12215b-5beb-6be6-ba64-0e9512501819.png",
      "20260317152646-1f12215b-5ed3-6a98-9602-0e9512501819.png"
    ],
    "Forest Green": [
      "20260317152646-1f12215b-5f7c-65a8-a486-7ea95006f86e.png",
      "20260317152647-1f12215b-6862-6c3a-9e5a-428b749b1d93.png"
    ],
    "Military Green": [
      "20260317152647-1f12215b-611e-6f50-a343-be7a817504ba.png",
      "20260317152647-1f12215b-65fb-6e4c-854d-6671f4e86556.png"
    ]
  },
  "unisex-cotton-crew-tee": {
    "Heather Grey": [
      "20260317042838-1f121b9c-5288-6ece-a14b-96de11f0a336.png",
      "20260317042844-1f121b9c-8775-6380-be23-4efb8b7de50b.png"
    ],
    "Solid Black": [
      "20260317042859-1f121b9d-1a16-69fa-851d-0e4d0be67922.png",
      "20260317042901-1f121b9d-30a5-66e4-9944-324a766c44dd.png"
    ],
    "Solid Heavy Metal": [
      "20260317042856-1f121b9c-fc4d-68f6-99d7-ce0de34da8c7.png",
      "20260317042901-1f121b9d-2d50-6994-bb82-56ad96522329.png"
    ],
    "Solid Midnight Navy": [
      "20260317042920-1f121b9d-e572-6a7c-b292-b62ea33dc198.png",
      "20260317042922-1f121b9d-f8e3-6408-931c-56ad96522329.png"
    ],
    "Solid Military Green": [
      "20260317042907-1f121b9d-677a-6e1c-a21c-96b5b5d9087e.png",
      "20260317042909-1f121b9d-7c45-695a-8e18-56ad96522329.png"
    ],
    "Solid Red": [
      "20260317042935-1f121b9e-74e8-697c-a8e4-1a8749dbf113.png",
      "20260317042937-1f121b9e-87ad-681e-a75d-324a766c44dd.png"
    ],
    "Solid White": [
      "20260317042845-1f121b9c-9196-6e72-bb94-1a8749dbf113.png",
      "20260317042847-1f121b9c-a710-6442-8b30-2649bc0dfe0e.png"
    ],
    "Solid Cool Blue": [
      "20260317042917-1f121b9d-c331-6440-b331-96b5b5d9087e.png",
      "20260317042918-1f121b9d-d31b-6748-8215-96b5b5d9087e.png"
    ],
    "Solid Dark Chocolate": [
      "20260317042900-1f121b9d-23b5-6718-a501-1a8749dbf113.png",
      "20260317042902-1f121b9d-3261-6cbc-b937-861a78a9bff4.png"
    ],
    "Solid Forest Green": [
      "20260317042911-1f121b9d-879a-6ca6-a3eb-96b5b5d9087e.png",
      "20260317042913-1f121b9d-9aa0-6012-a912-b62ea33dc198.png"
    ],
    "Solid Light Grey": [
      "20260317042902-1f121b9d-31c7-6aea-9767-861a78a9bff4.png",
      "20260317042906-1f121b9d-5be4-6332-ba2d-a20395aa8211.png"
    ],
    "Solid Light Pink": [
      "20260317042927-1f121b9e-2812-6aa8-a1b0-6ae62ea48e41.png",
      "20260317042934-1f121b9e-6372-6eae-8339-1a8749dbf113.png"
    ],
    "Solid Purple Rush": [
      "20260317042924-1f121b9e-0745-67a8-824e-6ae62ea48e41.png",
      "20260317042926-1f121b9e-1aa6-6d60-8467-aefde22860b1.png"
    ],
    "Solid Tahiti Blue": [
      "20260317042914-1f121b9d-aa44-6fae-8380-861a78a9bff4.png",
      "20260317042916-1f121b9d-b9fe-6148-b8ed-6ae62ea48e41.png"
    ]
  },
  "unisex-heavy-blend™-crewneck-sweatshirt": {
    "Heliconia": [
      "20260317051416-1f121c02-4e44-6bf4-a8c7-324a766c44dd.png",
      "20260317051416-1f121c02-5393-6c22-b4dd-1a8749dbf113.png"
    ],
    "Light Pink": [
      "20260317051417-1f121c02-5aed-64f0-bce8-0e4d0be67922.png",
      "20260317051417-1f121c02-5b98-613e-9f2a-aefde22860b1.png"
    ],
    "Navy": [
      "20260317051419-1f121c02-6a35-62b4-969e-b62ea33dc198.png",
      "20260317051417-1f121c02-5eab-6448-bc92-96de11f0a336.png"
    ],
    "Purple": [
      "20260317051416-1f121c02-533f-6ca8-a9ba-ce0de34da8c7.png",
      "20260317051416-1f121c02-4f63-6972-b8f6-a20395aa8211.png"
    ],
    "Sport Grey": [
      "20260317051416-1f121c02-50a4-6476-a8d9-2649bc0dfe0e.png",
      "20260317051416-1f121c02-4c5a-6a1e-8ab9-a20395aa8211.png"
    ],
    "White": [
      "20260317051416-1f121c02-4fd0-646e-a6a7-a20395aa8211.png",
      "20260317051419-1f121c02-69d3-6cbc-8e85-0e4d0be67922.png"
    ],
    "Black": [
      "20260317051417-1f121c02-5e04-6fa8-8e59-ce0de34da8c7.png",
      "20260317051416-1f121c02-5152-6cb0-8e96-1a8749dbf113.png"
    ],
    "Indigo Blue": [
      "20260317051417-1f121c02-5ca7-6674-a9ef-0e4d0be67922.png",
      "20260317051416-1f121c02-53b5-69b2-8948-2649bc0dfe0e.png"
    ],
    "Military Green": [
      "20260317051417-1f121c02-5dbc-682a-af26-324a766c44dd.png",
      "20260317051416-1f121c02-5325-690c-af81-b62ea33dc198.png"
    ]
  },
  "unisex-cotton-crew-tee-1": {
    "Heather Grey": [
      "20260317154225-1f12217e-539b-6afe-8261-f21eb9380f3f.png",
      "20260317154225-1f12217e-5431-6f86-91c9-e634b792a2bc.png"
    ],
    "Solid Black": [
      "20260317154222-1f12217e-3bbb-668c-8644-fa14d8a9840d.png",
      "20260317154223-1f12217e-449b-604a-b251-e20372856a5c.png"
    ],
    "Solid Midnight Navy": [
      "20260317154224-1f12217e-4cf5-6146-8cc9-926726e4ef75.png",
      "20260317154224-1f12217e-4e2a-67e6-957f-b6b65fe7774c.png"
    ],
    "Solid Military Green": [
      "20260317154223-1f12217e-44e7-6846-b840-428b749b1d93.png",
      "20260317154224-1f12217e-4a8c-6882-b6d4-b6b65fe7774c.png"
    ],
    "Solid Red": [
      "20260317154223-1f12217e-47d9-6e1e-899f-c659e166c14a.png",
      "20260317154224-1f12217e-4fe6-665c-99c1-a2594d4c901c.png"
    ],
    "Solid White": [
      "20260317154223-1f12217e-402a-6e52-8312-6ebff3a88be9.png",
      "20260317154223-1f12217e-43ec-622a-8590-1e929a84de5b.png"
    ],
    "Solid Cool Blue": [
      "20260317154224-1f12217e-4a28-6e18-b62c-f26ccc857799.png",
      "20260317154224-1f12217e-4de9-6ca0-8efa-32c95e3442e8.png"
    ],
    "Solid Light Pink": [
      "20260317154224-1f12217e-49ce-65da-8eed-0e9512501819.png",
      "20260317154224-1f12217e-4ee3-6b7e-adbf-f21eb9380f3f.png"
    ],
    "Solid Maroon": [
      "20260317154224-1f12217e-4977-644c-a198-b6b65fe7774c.png",
      "20260317154224-1f12217e-4ae6-6288-8160-7ea95006f86e.png"
    ],
    "Solid Purple Rush": [
      "20260317154224-1f12217e-4dfe-6a06-9e1c-fafae4bc6621.png",
      "20260317154224-1f12217e-4ce9-6c7e-84b3-32c95e3442e8.png"
    ]
  },
  "unisex-heavy-blend™-hooded-sweatshirt-1": {
    "Dark Heather": [
      "20260317162527-1f1221de-8b4f-6e22-ac01-fa0eb0ec4575.png",
      "20260317162527-1f1221de-8bf6-6af6-b179-da0e2e6057a3.png"
    ],
    "Maroon": [
      "20260317162527-1f1221de-8919-623e-bfc1-fa0eb0ec4575.png",
      "20260317162527-1f1221de-89a8-665a-9a73-4ab78a3ae747.png"
    ],
    "Navy": [
      "20260317162527-1f1221de-8b23-6610-aa84-4e6735b29299.png",
      "20260317162527-1f1221de-8a58-6dca-aad2-9ef1001b4d2c.png"
    ],
    "White": [
      "20260317162527-1f1221de-8ac5-6a56-b1e4-b2fbefe6f758.png",
      "20260317162528-1f1221de-8cb2-60d0-afc4-9a4b574b7bb5.png"
    ],
    "Black": [
      "20260317162527-1f1221de-86b5-6d1c-9d62-26020e7233f0.png",
      "20260317162527-1f1221de-886a-631a-9102-a22e6fdaa5b8.png"
    ],
    "Royal": [
      "20260317162527-1f1221de-88a0-6352-91bd-fa9ac5309aa4.png",
      "20260317162527-1f1221de-8885-664c-bd25-aef724eef6a6.png"
    ],
    "Light Pink": [
      "20260317162527-1f1221de-89e3-60f2-9006-4ab78a3ae747.png",
      "20260317162527-1f1221de-8ab2-6d34-8b10-ca14f142cf36.png"
    ],
    "Light Blue": [
      "20260317162527-1f1221de-8a94-6ae6-b5a8-1e779cdda39c.png",
      "20260317162528-1f1221de-8da5-69c4-8b85-b6803fbea119.png"
    ]
  },
  "unisex-heavy-blend™-full-zip-hooded-sweatshirt": {
    "Red": [
      "20260318205711-1f1230d0-9003-63e6-8369-0209c70431dc.png"
    ],
    "Royal": [
      "20260318205711-1f1230d0-901f-67c6-bdc1-0264d4a9dab5.png"
    ],
    "Sport Grey": [
      "20260318205712-1f1230d0-981f-6f5c-bf01-ae1e164f3131.png"
    ],
    "White": [
      "20260318205711-1f1230d0-8fcd-6688-81d9-0297682156b8.png"
    ],
    "Maroon": [
      "20260318205711-1f1230d0-8f99-6932-aafa-86527f6dcb15.png"
    ],
    "Safety Orange": [
      "20260318205711-1f1230d0-909b-6a6a-af8d-0297682156b8.png"
    ],
    "Forest Green": [
      "20260318205711-1f1230d0-8b4a-6b88-b11a-3a89fb4308c8.png"
    ]
  },
  "flat-bill-cap-embroidery": {
    "Grey": [
      "20260318210230-1f1230dc-7083-6dde-84b1-9a7673c121ba.png"
    ],
    "Red": [
      "20260318210229-1f1230dc-6a03-6040-9007-123e33442651.png"
    ],
    "White": [
      "20260318210224-1f1230dc-3a1a-639c-b443-9a6e3c1fff03.png"
    ],
    "Royal": [
      "20260318210227-1f1230dc-4ea9-6f38-b327-c2b5cdfbdd15.png"
    ]
  },
  "nyc-oversized-tee": {
    "Black": [
      "20260608025140-1f162e4f-9d59-69de-93ad-467d2a0b8d0e.png",
      "20260608025140-1f162e4f-9baf-6df4-80a8-ce8127df7ef0.png"
    ],
    "White": [
      "20260608025140-1f162e4f-99fc-600c-aaf3-56a5a4580f85.png",
      "20260608025141-1f162e4f-a62b-6314-ba9a-725eb03103cc.png"
    ],
    "Athletic Heather": [
      "20260608025144-1f162e4f-bb62-6ab6-bb62-b23633d9b3e9.png"
    ],
    "Navy": [
      "20260608025140-1f162e4f-947f-60b6-b068-02afb1c6641d.png"
    ],
    "Red": [
      "20260608025140-1f162e4f-995f-69aa-ba4c-6ab400e004c2.png"
    ],
    "Midnight Blue": [
      "20260608025140-1f162e4f-9b6f-6f88-89bf-8e4313555b3d.png"
    ],
    "Pine Green": [
      "20260608025140-1f162e4f-977a-65ea-b24e-f2dd8ffe66fb.png",
      "20260608025140-1f162e4f-9904-6faa-aa1f-e660c4264bf0.png"
    ],
    "Pistachio": [
      "20260608025141-1f162e4f-a31f-6f6c-9ae3-56a5a4580f85.png"
    ]
  },
  "unisex-sweatshirt": {
    "Black": [
      "20260915030548-1f1b0b25-9be5-65f0-b06f-e67776ecdc83.png",
      "20260915030550-1f1b0b25-af23-6216-a091-4e3df889ca8e.png"
    ],
    "Crimson": [
      "20260915030550-1f1b0b25-b466-6b56-b79b-ea7665820c93.png",
      "20260915030551-1f1b0b25-bd1b-6936-9f09-7ac293f94334.png"
    ],
    "Espresso": [
      "20260915030549-1f1b0b25-a8dd-6d0c-820c-0e1f4dc2f3b2.png",
      "20260915030551-1f1b0b25-bb70-6028-9cd0-b2be030c063f.png"
    ],
    "Grey": [
      "20260915030549-1f1b0b25-a650-6418-bf19-42ac01011870.png",
      "20260915030551-1f1b0b25-bab1-6e16-a9e8-ea7665820c93.png"
    ],
    "White": [
      "20260915030543-1f1b0b25-6bc4-60c4-8e96-e67776ecdc83.png",
      "20260915030548-1f1b0b25-9fdc-6e10-ae9d-86e281da01cf.png"
    ],
    "Hydrangea": [
      "20260915030545-1f1b0b25-830a-642c-ae91-5625c850d26e.png",
      "20260915030549-1f1b0b25-a844-654e-aeb9-e67776ecdc83.png"
    ],
    "Blue Jean": [
      "20260915030551-1f1b0b25-b8a7-66ac-bdc6-ea7665820c93.png",
      "20260915030551-1f1b0b25-bda5-637a-8bf1-9642413ed246.png"
    ]
  }
};
